import { RegisterOptions } from 'react-hook-form';
import { ModalStates } from '../../../hooks/useModal';
import { EMAIL_REGEX } from '../../../utilities/consts';
import { Organization } from '..';

type OrgActionModalInputRules = {
  name: RegisterOptions;
  email: RegisterOptions;
  organizationType: RegisterOptions;
};

export type OrgActionModalFormFields = {
  name: string;
  active: boolean;
  nhsSupport: boolean;
  email: string;
  organizationType: string;
  hba1cConfig: boolean;
  parentId: string;
};

export type OrganizationActionModalProps = {
  onClose: () => void;
  modalState: ModalStates;
  addOrganization: (
    name: string,
    active: boolean,
    isConsOrganization: boolean,
    nhsSupport: boolean,
    email?: string,
    parentId?: string
  ) => void;
  editOrganization: (
    name: string,
    active: boolean,
    nhsSupport: boolean,
    email: string,
    hba1cConfig: boolean
  ) => void;
  selectedOrganization?: Organization;
};

export const orgActionModalInputRules: OrgActionModalInputRules = {
  name: {
    required: 'Required field',
    minLength: {
      value: 2,
      message: 'Name must contain min 2 and max 50 characters',
    },
    maxLength: {
      value: 50,
      message: 'Name must contain min 2 and max 50 characters',
    },
  },
  email: {
    required: 'Required field',
    pattern: {
      value: EMAIL_REGEX,
      message: 'Invalid email format',
    },
  },
  organizationType: {
    required: 'Required field',
  },
};

export const hcpInfoItems = [
  `If the status of the organization is set to “Inactive”,
  all HCPs from that organization will be set to “Inactive”, too`,
];

export const consumerInfoItems = [
  `Changing the status of the organization to “Inactive”
  does not impact consumer users`,
];

export const NAME_UNAVAILABLE = 'This organization already exists in the system';

export const defaultFieldValues: OrgActionModalFormFields = {
  name: '',
  active: true,
  nhsSupport: false,
  email: '',
  organizationType: '',
  parentId: '',
  hba1cConfig: false,
};
